import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';



@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class CeoTakim extends Vue {
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;



  product: ProductDefinition;




  defHideObjects = [
    '_yyy',

  ];

  defShowObjects =  [
    'duvarlar_yyy',
    'zemin_yyy',
    'ori_yyy',
    'sedna_luxe',
    'apsis_toplanti_masa_yyy',
    'ceo_masa_yyy',
    'ceo_toplanti_masasi_yyy',
    'ceo_sehpa_yyy',
    'ceo_dolap_yyy',
    'ceo_tv',
    '_koltuk',

  ];booleaboolean;

  isWall: boolean = true;


  seletedTable: string = GordionTable.Tekil;
  seletedMeetingTable: string = GordionMeetingTable.Klasik;
  availableAnimations: AnimationDefinition[] = [];
  private _nodeMap: NodeMap[] = null;

  async created() {
    this.product = Store.getProductById('ceo_takim');
    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);

    this.availableAnimations =  [];
    this.availableAnimationsChanged();
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });



    if (Store.state.selection) {
      Store.state.selection.parts.forEach((element) => {
        this.colorChanged(element.color,element.palette,element.id);
      });


    } else {
      await  this.applyDefaultSelection();
    }

  }


  async changeWall(wall: boolean) {
    if (wall) {

      await this._configuratorService.showObjects({ objects:  ['duvarlar_yyy'], operator: FilterOperators.Contains });
    } else {


      await this._configuratorService.hideObjects({ objects:  ['duvarlar_yyy'], operator: FilterOperators.Contains });
    }
    this.isWall = wall;
  }
  availableAnimationsChanged() {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }

  async applyDefaultSelection() {
    const selection = new BasicEtajerliMasaSelection();

    selection.parts = [];

    console.log(this.product.defaults.parts);
    this.product.defaults.parts.forEach((element) => {
      this.colorChanged(element.color,element.palette,element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.name = element.name;
      part.palette = element.palette;
      selection.parts.push(part);
    });
    Store.state.selection = selection;

  }

  async changeTable(table:GordionTable) {
    if (table === GordionTable.Tekil) {
      await this._configuratorService.hideObjects({ objects: ['ceo_etajerli_masa_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['ceo_masa_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.table = GordionTable.Tekil;
      this.seletedTable = GordionTable.Tekil;
    }
    if (table === GordionTable.Etajer) {
      await this._configuratorService.hideObjects({ objects: ['ceo_masa_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['ceo_etajerli_masa_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.table = GordionTable.Etajer;
      this.seletedTable = GordionTable.Etajer;
    }

  }

  async changeMeetingTable(table:GordionMeetingTable) {
    if (table === GordionMeetingTable.Klasik) {
      await this._configuratorService.hideObjects({ objects: ['ceo_oval_toplanti_masasi_yyy','ceo_yuvarlak_toplanti_masasi_yyy','_koltuk'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['ceo_toplanti_masasi_yyy','_koltuk'], operator: FilterOperators.Contains });
      Store.state.selection.meetingTable = GordionMeetingTable.Klasik;
      this.seletedMeetingTable = GordionMeetingTable.Klasik;
    }
    if (table === GordionMeetingTable.Yuvarlak) {
      await this._configuratorService.hideObjects({ objects: ['ceo_toplanti_masasi_yyy','ceo_oval_toplanti_masasi_yyy','_koltuk'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['ceo_yuvarlak_toplanti_masasi_yyy','yuvarlak_toplanti_koltuk_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.meetingTable = GordionMeetingTable.Yuvarlak;
      this.seletedMeetingTable = GordionMeetingTable.Yuvarlak;
    }
    if (table === GordionMeetingTable.Oval) {
      await this._configuratorService.hideObjects({ objects: ['ceo_toplanti_masasi_yyy','ceo_yuvarlak_toplanti_masasi_yyy','_koltuk'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['ceo_oval_toplanti_masasi_yyy','yuvarlak_toplanti_koltuk_yyy','oval_toplanti_koltuk_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.meetingTable = GordionMeetingTable.Oval;
      this.seletedMeetingTable = GordionMeetingTable.Oval;
    }

  }

  async colorChanged(color: any,palette: any,part: any) {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
    if (part === 'apsis_workstation_separator') {

      if (palette === 'pleksi') {
        await this._configuratorService.hideObjects({ objects: ['apsis_separator_melamin_yyy','apsis_separator_melamin2_yyy'], operator: FilterOperators.Contains });
        await this._configuratorService.showObjects({ objects:  ['apsis_separator_cam_yyy','apsis_separator_cam2_yyy'], operator: FilterOperators.Contains });
      } else {

        await this._configuratorService.showObjects({ objects: ['apsis_separator_melamin_yyy','apsis_separator_melamin2_yyy'], operator: FilterOperators.Contains });
        await this._configuratorService.hideObjects({ objects:  ['apsis_separator_cam_yyy','apsis_separator_cam2_yyy'], operator: FilterOperators.Contains });
      }

    }
    if (part === 'apsis_dolap_kapak') {

      if (palette === 'pleksi') {
        await this._configuratorService.hideObjects({ objects: ['apsis_dolap_kapak_2_yyy'], operator: FilterOperators.Contains });
        await this._configuratorService.showObjects({ objects:  ['apsis_dolap_kapak_yyy'], operator: FilterOperators.Contains });
      } else {

        await this._configuratorService.showObjects({ objects: ['apsis_dolap_kapak_2_yyy'], operator: FilterOperators.Contains });
        await this._configuratorService.hideObjects({ objects:  ['apsis_dolap_kapak_yyy'], operator: FilterOperators.Contains });
      }

    }
    if (palette === 'compact') {

      await this._configuratorService.showObjects({ objects:  ['_kenar'], operator: FilterOperators.Contains });
    } else {


      await this._configuratorService.hideObjects({ objects:  ['_kenar'], operator: FilterOperators.Contains });
    }
  }

}



export class BasicEtajerliMasaSelection {

  parts: PartSelection[];
}

export class PartSelection {
  id: string;
  palette: string;
  name: string;
  color: string;

}

enum GordionTable {
  Tekil = 'tekil',
  Etajer = 'etajer',

}

enum GordionMeetingTable {
  Klasik = 'klasik',
Yuvarlak = 'yuvarlak',
Oval= 'oval',


}



// WEBPACK FOOTER //
// ./src/components/families/ceo/CeoTakim.ts